module.exports = __webpack_public_path__ + "img/accra-polo.bcffe908.webp";